import React from 'react';

import { WrapperForm } from 'components/WrapperForm';

export const WrapperSettings = ({ value, onChange }) => {
  return (
    <div>
      <h3>Wrapper</h3>
      {/* <TestReceiptButton /> */}
      <WrapperForm
        value={value}
        onChange={(k, v) => onChange({ ...value, [k]: v })}
        getMessage="config:getPrintingFields"
        setMessage="config:setPrintingFields"
        updateMessage="config:setPrintingConfig"
      />
    </div>
  );
};
